import React from 'react';
import { useIntl } from '@kamernet/core/Intl';
import { Typography } from '@mui/material';
import { PageLayout } from '@kamernet/core/PageLayout';
import PostAdvertIcon from '@kamernet/icons/PostAdvert.svg';
import ReceiveMessagesIcon from '@kamernet/icons/ReceiveMessages.svg';
import MessageMultipleIcon from '@kamernet/icons/MessageMultiple.svg';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';
import styles from './Features.module.css';

export const Features = () => {
  const { T } = useIntl();
  const typographyVariant = useMediaIsDesktop() ? 'h5' : 'body2';

  return (
    <PageLayout.SectionContainer
      className={styles.root}
      containerClassName={styles.sectionContainer}
    >
      <PostAdvertIcon fontSize="large" />
      <Typography variant={typographyVariant}>
        {T('LBL_HOME_SUPPLY_USP1_ROOM')}
      </Typography>
      <ReceiveMessagesIcon fontSize="large" />
      <Typography variant={typographyVariant}>
        {T('LBL_HOME_SUPPLY_USP2_HOME')}
      </Typography>
      <MessageMultipleIcon fontSize="large" />
      <Typography variant={typographyVariant}>
        {T('LBL_HOME_SUPPLY_USP3_HOME')}
      </Typography>
    </PageLayout.SectionContainer>
  );
};
